<template>
  <div class="rule">
    <img src="../assets/rule.png" alt="rule" class="rule-img" />
    <p class="msg">
      1、活动时间：7月18日~7月20日；
      <br />2、每天登录游戏可以抽奖一次，抽中奖品后，请到“我的奖品”填写领奖信息；
      <br />3、京东卡获奖者请留下您的收奖邮箱；
      <br />4、实物奖品获奖者请留下您的快递信息(收件人、手机号、地址)；
      <br>5、领奖截止至7月27日,逾期作弃奖处理；
      <br>6、奖品将在活动结束后15个工作日内发放；
      <br>7、如有任何问题请加雷电官方福利群:601299812咨询；
      <br>8、活动最终解释权归雷电模拟器官方所有。
    </p>
  </div>
</template>

<script>
export default {
  name: "Rule"
};
</script>

<style lang="scss" scoped>
.rule {
  padding: 50px 0 0 0;
  width: 680px;
  margin: 0 auto;
  .rule-img {
    display: block;
    width: 400px;
    margin: 0 auto;
    margin-bottom: 30px;
  }
  .msg{
      font-size: 16px;
      line-height: 36px;
      color:#9059c0;
      padding-bottom: 50px;
  }
}
</style>
